module.exports = __webpack_public_path__ + "assets/img/main-feature-1.379cec2c.png";